"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = _interopRequireDefault(require("./styles"));
var _Trackings = _interopRequireDefault(require("../../services/Trackings"));
var _Auth = require("../../contexts/Auth");
var _Array = _interopRequireDefault(require("../../utils/Array"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function Chapter(_ref) {
  var {
    chapter,
    pdf
  } = _ref;
  var {
    auth
  } = (0, _Auth.useAuth)();
  var trackService = (0, _Trackings.default)(auth);
  var getChapterPage = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* (param) {
      if (pdf) {
        var chapterPage = yield pdf.props.pdfDocument.getPageIndex(param.dest[0]);
        trackService.trackChapterSelected({
          selectedChapter: chapter.title
        });
        trackService.trackPageView({
          currentPage: pdf.viewer.currentPageNumber
        });
        return pdf.viewer.currentPageNumber = chapterPage + 1;
      }
    });
    return function getChapterPage(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react.default.createElement(_core.ListItem, {
    button: true,
    onClick: () => getChapterPage(chapter)
  }, /*#__PURE__*/_react.default.createElement(_core.ListItemText, {
    primary: chapter.title
  }));
}
function ChaptersList(_ref3) {
  var {
    chapters,
    pdf,
    getChapterPage
  } = _ref3;
  var classes = (0, _styles.default)();
  return /*#__PURE__*/_react.default.createElement(_core.List, {
    component: "nav",
    className: classes.root
  }, chapters && _Array.default.flattenArray(chapters, 'items').map((chapter, index) => /*#__PURE__*/_react.default.createElement(Chapter, {
    chapter: chapter,
    key: index,
    index: index,
    getChapterPage: getChapterPage,
    pdf: pdf,
    classes: classes
  })));
}
ChaptersList.propTypes = {
  pdf: _propTypes.default.object,
  chapters: _propTypes.default.array
};
var _default = exports.default = ChaptersList;